(() => {
    class DisplayOrderModal {
        constructor(
            $scope,
            $state,
            $uibModalInstance,
            LandingPagesService,
            ImageResourceService,
            Id,
            Title,
            ResourceId,
            DisplayOrder,
            GroupId
        ) {
            $scope.close = $uibModalInstance.close;
            $scope.generateResourceUrl = (id) => {
                return ImageResourceService.getUrlForResource(id);
            }
            $scope.currentId = Id;
            $scope.items = []

            LandingPagesService.fetchDisplayOrder($state.params.brandId)
                .then((data) => {
                    const unOrderedItems = [
                        ...data.filter(x => x.Id !== Id),
                        {
                            Id,
                            Title,
                            ResourceId,
                            DisplayOrder
                        } ]

                    $scope.items = [ ...unOrderedItems ]
                        .sort((a, b) => Number(a.DisplayOrder) - Number(b.DisplayOrder))
                })

            $scope.save = function () {
                const list = document.getElementById('displayOrderList');
                const items = list.querySelectorAll("li>span");
                const orderedItems = []
                items.forEach((element, index) => {
                    orderedItems.push({
                        Id: Number(element.getAttribute("data-id")),
                        DisplayOrder: index + 1,
                        GroupId
                    })
                })
                LandingPagesService.updateDisplayOrder(orderedItems)
                    .finally(() => {
                        $uibModalInstance.close();
                    })
            }
        }
    }

    angular.module("dashboard")
        .controller("displayOrderModal", [
            "$scope",
            "$state",
            "$uibModalInstance",
            "LandingPagesService",
            "ImageResourceService",
            "id",
            "title",
            "resourceId",
            "displayOrder",
            "brandId",
            DisplayOrderModal ]
        )
})();
